// MARK: Types
import Color from "types/globals/styleguide/color";
// MARK: Function
const getColors = (colors: Array<Color>, slug: string) => {
  const color = colors.filter((color) => color.slug === slug)[0];
  return color === undefined || color === null ? "#1d1d1f" : color.cssColor;
};

export default getColors;
